import { SegmentedBar, SegmentedOption } from './Segmented.styles'

export interface SegmentedOptionDef<T extends string> {
	value: T
	label: string
}

export interface SegmentedProps<T extends string> {
	options: ReadonlyArray<SegmentedOptionDef<T>>
	value: T
	onChange: (value: T) => void
	/** Names the group for assistive tech — the options alone do not say what they switch. */
	'aria-label': string
	className?: string
}

/**
 * The app's segmented control: a radiogroup of two to four mutually exclusive
 * options, controlled through `value` / `onChange`. Wrap it in a styled
 * container for spacing rather than restyling the bar.
 */
export function Segmented<T extends string>({ options, value, onChange, className, 'aria-label': ariaLabel }: SegmentedProps<T>) {
	return (
		<SegmentedBar role="radiogroup" aria-label={ariaLabel} className={className}>
			{options.map(option => (
				<SegmentedOption
					key={option.value}
					type="button"
					role="radio"
					aria-checked={option.value === value}
					$selected={option.value === value}
					onClick={() => onChange(option.value)}
				>
					{option.label}
				</SegmentedOption>
			))}
		</SegmentedBar>
	)
}

export default Segmented
